import { useEffect, useState } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import FacebookIcon from '../submenu/FacebookIcon';
import InstagramIcon from '../submenu/InstagramIcon';
import LinkedInIcon from '../submenu/LinkedInIcon';
import LocationIcon from '../submenu/LocationIcon';
import PhoneIcon from '../submenu/PhoneIcon';
import TwitterIcon from '../submenu/TwitterIcon';
import YouTubeIcon from '../submenu/YouTubeIcon';
import TandCsIcon from './T&CsIcon';
import TipsIcon from './TipsIcon';
import GuestSignInLogo from '../GuestSignInLogo';
import MobileSettingsIcon from '../../MobileSettingsIcon';
import MobileItemsAndPostsIcon from '../../MobileItemsAndPostsIcon';
import NotificationsIcon from '../NotificationsIcon';
import PrivacyPolicyIcon from './PrivacyPolicyIcon';
import { useToken } from '../../auth/useToken';
import { useLogout } from '../../auth/useLogout';
import Modal from '../../Modal';
import useUserDataStore from '../../../store/userDataStore';
import ViewProfile from '../../pages/ViewProfile/ViewProfile';
import { useRole } from '../../../hooks/useRole';

export default function HamSubMenu({ hamSubMenuOpen, closeMenu }) {
  const currentYear = new Date().getFullYear();
  const logout = useLogout();
  const navigate = useNavigate();
  const [token] = useToken();
  const { role } = useRole();
  const { firstname, lastname, email, phoneNumber, image } = useUserDataStore(
    (state) => state.userData
  );
  const [height, setHeight] = useState(window.innerHeight);
  const [openModal, setOpenModal] = useState(false);
  const location = useLocation();

  const toggleModal = (e) => {
    e.preventDefault();
    setOpenModal(!openModal);
  };

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      const viewportHeight = window.innerHeight;
      const divHeight = viewportHeight;
      setHeight(divHeight);
    }, 10);
  }, []);

  // Disable/enable body scroll when menu is open/closed
  useEffect(() => {
    if (hamSubMenuOpen === 'ham-sub-menu') {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Cleanup function to ensure scroll is re-enabled when component unmounts
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [hamSubMenuOpen]);

  const logOut = () => {
    logout();
    navigate('login');
    closeMenu();
  };

  const navToAdmin = () => {
    if (location.pathname !== '/swapandtop/admin') {
      navigate('admin');
      closeMenu();
    }
  };

  return (
    <>
      <Modal open={openModal} toggleModal={toggleModal}>
        <ViewProfile
          userName={`${firstname} ${lastname}`}
          sellerEmail={email}
          phoneNumber={phoneNumber}
          image={image}
          // toggleModal={toggleModal}
        />
      </Modal>

      {hamSubMenuOpen === 'ham-sub-menu' && (
        <div className='ham-submenu-overlay' onClick={closeMenu}></div>
      )}

      <div className={hamSubMenuOpen}>
        <div className='ham-sub-menu-scrollable'>
          <div className='sub-menu ham-profile-sub-menu'>
            <div className='ham-profile-pic-name-wrap'>
              <div className='ham-pic-wrap' onClick={toggleModal}>
                {image ? (
                  <img src={image} alt='User profile pic' />
                ) : (
                  <div
                    className='guest-icon-wrapper'
                    style={{ marginBottom: '6px' }}>
                    <GuestSignInLogo fillColor={'var(--blue-text-bold)'} />
                  </div>
                )}
                <p>View Profile</p>
              </div>

              <div className='sub-menu-content'>
                <h6 className='ham-user-name'>{`${firstname} ${lastname}`}</h6>
                {role && role.toLowerCase() !== 'user' && (
                  <span
                    className='ham-user-role-tag'
                    onClick={navToAdmin}
                    title={
                      location.pathname === '/swapandtop/admin'
                        ? null
                        : 'Go to Admin Dashboard'
                    }
                    style={{
                      pointerEvents: `${
                        location.pathname === '/swapandtop/admin'
                          ? 'none'
                          : 'initial'
                      }`,
                    }}>
                    {role?.charAt(0).toUpperCase() +
                      role?.slice(1).toLowerCase()}
                  </span>
                )}
                <span
                  className='selectable-text-log-out'
                  onClick={() => logOut()}>
                  Log Out
                </span>
              </div>
            </div>
            <div className='ham-profile-menu-items-wrap'>
              <NavLink
                to='/swapandtop/myitemsandposts'
                className='ham-sub-menu-link'
                onClick={closeMenu}>
                <div className='ham-profile-text-wrap'>
                  <MobileItemsAndPostsIcon
                    svgClass={'ham-sub-menu-icon ham-profile-icon'}
                    wrapperClass={'ham-profile-icon-wrap'}
                  />
                  <p>My posts & watchlist</p>
                </div>
              </NavLink>
              <NavLink to='/swapandtop/settings' onClick={closeMenu}>
                <div className='ham-profile-text-wrap'>
                  <MobileSettingsIcon
                    svgClass={'ham-sub-menu-icon ham-profile-icon'}
                    wrapperClass={'ham-profile-icon-wrap'}
                  />
                  <p>Settings</p>
                </div>
              </NavLink>
              <div className='ham-profile-text-wrap'>
                <NotificationsIcon
                  svgClass={'ham-sub-menu-icon ham-profile-icon'}
                  wrapperClass={'ham-profile-icon-wrap'}
                />
                <p>Notifications</p>
              </div>
            </div>
          </div>

          <div className='sub-menu ham-about-sub-menu'>
            <div className='ham-profile-menu-items-wrap'>
              <NavLink
                to='/swapandtop/tou'
                className='ham-about-text-wrap'
                onClick={closeMenu}>
                <TandCsIcon svgClass={'ham-sub-menu-icon'} />
                View terms of use
              </NavLink>
              <NavLink
                to='/swapandtop/privacypolicy'
                className='ham-about-text-wrap'
                onClick={closeMenu}>
                <PrivacyPolicyIcon svgClass={'ham-sub-menu-icon'} />
                View privacy policy
              </NavLink>
              <NavLink
                to='/swapandtop/tipsandrecomandations'
                className='ham-about-text-wrap'
                onClick={closeMenu}>
                <TipsIcon svgClass={'ham-sub-menu-icon'} />
                View tips & recomendations
              </NavLink>
            </div>
          </div>

          <div className='sub-menu ham-contact-us-submenu'>
            <div className='ham-contact-details-wrap'>
              <div className='ham-contact-details'>
                <PhoneIcon svgClass={'ham-sub-menu-icon'} />
                <div>
                  <p>+263774 689 010</p>
                  <p>+263784 224 614</p>
                  <p>+263719 217 717</p>
                </div>
              </div>
              <div className='ham-contact-details'>
                <LocationIcon svgClass={'ham-sub-menu-icon'} />
                <div>
                  <p>4442 Ceres Ave</p>
                  <p>Waterfalls</p>
                  <p>Harare</p>
                </div>
              </div>
            </div>
          </div>
          <div className='sub-menu ham-socials-sub-menu'>
            <div className='ham-feedback-sub-menu'>
              <p>Your feedback is very iportant to us.</p>
              <p>Please e-mail us at</p>
              <a className='selectable-text'>feedback@swapandtop.co.zw</a>
            </div>
            <div className='socials-sub-menu-icons-wrap'>
              <p>Check us out on social</p>
              <div className='ham-socials-icons-wrap'>
                <a href='https://www.facebook.com' target='_blank'>
                  <FacebookIcon socialIconClass={'ham-social-icon'} />
                </a>
                <a href='https://www.twitter.com' target='_blank'>
                  <TwitterIcon socialIconClass={'ham-social-icon'} />
                </a>
                <a href='https://www.youtube.com' target='_blank'>
                  <YouTubeIcon socialIconClass={'ham-social-icon'} />
                </a>
                <a href='https://www.instagram.com' target='_blank'>
                  <InstagramIcon socialIconClass={'ham-social-icon'} />
                </a>
                <a href='https://www.linkedin.com' target='_blank'>
                  <LinkedInIcon socialIconClass={'ham-social-icon'} />
                </a>
              </div>
            </div>
            <div className='ham-sub-menu-company-name'>
              <a className='selectable-text'>
                © {currentYear} | Greta Works Inc.
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
